import React from 'react';
import {
  Placeholder,
  ComponentRendering,
  ComponentParams,
  ComponentFactory,
} from '@sitecore-jss/sitecore-jss-react';
import { Container, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export type APIComponentProps = {
  componentFactory: ComponentFactory;
  rendering: ComponentRendering;
  params: ComponentParams;
};

const ContainerFullWidth = styled(Container)(({ theme }) => ({
  padding: 0,
  maxWidth: '100%',
}));

export const OneColumnContentRowFullWidth = (props: APIComponentProps): JSX.Element => {
  return (
    <>
      <ContainerFullWidth maxWidth={false} disableGutters>
        <Grid container className="one-column-content-row content-row full-width">
          <Grid item xs={12}>
            <div>
              <Placeholder name="column_one" rendering={props.rendering} />
            </div>
          </Grid>
        </Grid>
      </ContainerFullWidth>
    </>
  );
};

export default OneColumnContentRowFullWidth;
